<template>
  <div>
    <div class="arrows-stop-box" v-if="Object.keys(stopDetail).length>0">
      <div class="content_table">
        <table width="100%">
          <tr>
            <th>出发地</th>
            <th>出发时间</th>
            <th>经停地</th>
            <th>停留时间</th>
            <th>抵达地</th>
            <th>抵达时间</th>
          </tr>
          <tr>
            <td>{{stopDetail[0].cityName}}</td>
            <td>{{stopDetail[0].depTime}}</td>
            <td>
              <b>{{stopDetail[1].cityName}}</b>
            </td>
            <td>
              <b>{{stopDetail[1].arrTime}}-{{stopDetail[1].depTime}}</b>
            </td>
            <td>{{stopDetail[2].cityName}}</td>
            <td>{{stopDetail[2].arrTime}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import detail from "@/lib/data-service/flight/buyer_dom_white_flight_stop";
export default {
  data() {
    return {
      stopDetail: {}
    };
  },
  props: {
    flightNo: {
      type: String,
      default: ""
    },
    stopNum: {
      type: Number,
      default: 0
    }
  },
  watch: {
    stopNum(val) {
      if (this.stopNum > 0) {
        this.getDetail();
      }
    }
  },
  created() {
    if (this.stopNum > 0 && this.flightNo) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      if (Object.keys(this.stopDetail).length > 0) return;
      let formData = this.$parent.$parent;
      let data = {
        date: this.$moment(formData.time1).format("YYYY-MM-DD"),
        flightNo: this.flightNo,
        supplierType: 1
      };
      detail(data).then(res => {
        this.stopDetail = res.result.stopInfos;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.arrows-stop-box {
  width: 600px;
  height: auto;
  background: white;
  z-index: 9999;
  border: 1px solid #6eaadb;
  position: absolute;
  left: -250px;
  top: 5px;
  .content_table {
    table {
      border-collapse: collapse;
      th {
        font-size: 12px;
        color: #9e9e9e;
        background: #eef0f4;
      }
      td {
        text-align: center;
        word-break: break-word;
        padding: 5px;
        font-size: 12px;
        color: #666666;
        i {
          font-size: 10px;
          font-style: normal;
        }
        b {
          color: black;
        }
      }
    }
    table td,
    table th {
      border: 1px solid #cad9ea;
      height: 30px;
      font-family: Microsoft YaHei;
    }
  }
}
</style>